module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("During the 1960s Ian Brady and Myra Hindley committed five murders against children that still shock to this day. While Brady had shown signs of disturbed behaviour from a young age, Hindley seemed to have a relatively normal upbringing, was good at sports and enjoyed poetry. She admitted to falling in love with Ian Brady almost at first sight, but it took Brady nearly a year even to notice her, let alone ask her out. From that moment on they became almost inseparable and went on to carry out some of the most heinous acts of murder ever committed anywhere in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was the first case of a woman being convicted of the murder of children on such a scale in the UK and it shocked the nation so much that the name ‘Myra’ has become almost obsolete.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is the true story of their childhoods, how they met, the depravity of their crimes and how they were caught.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebd71e74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Introduction.vue
// module id = 72
// module chunks = 0